import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './stepSlider.module.css';


function StepSlide(props) {
    return (
        <div className={styles.stepSlideItem}>
            <div className={styles.slideItemWrap}>
                <div className={styles.siImageWrap}>
                    {
                        (props.item.image) ?
                        <img src={props.item.image.image.asset.url} alt={props.item.title} />
                        : ``
                    }
                    <div className={styles.downloadLinks}>
                        {
                            (props.item.showDomainIcon) ?
                            <div className={styles.domainTab}>
                                <a href="javascript:void(0);">
                                    <img src={require('../images/domain-tab-2.png').default} alt="domain.com.au" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.item.showRealEstateIcon) ?
                            <div className={styles.realEstateTab}>
                                <a href="javascript:void(0);">
                                    <img src={require('../images/realestate-tab.png').default} alt="realestate.com.au" />
                                </a>
                            </div>
                            : ``
                        }
                    </div>
                </div>
                <div className={styles.siContentWrap}>
                    <h5>{props.item.title}</h5>
                    <h3>{props.item.heading}</h3>
                    <PortableText blocks={props.item.desc} />
                </div>
            </div>
        </div>
    );
}
  
export default StepSlide;